import React from 'react';
import { HeaderBarStyle } from '../../styles';
import { useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import { TextLarge } from '../../../text';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const HeaderLayout = () => {
  const history = useHistory();
  const title = useSelector((state) => state.title.title);
  const profile = useSelector((state) => state.line.profile);

  function handleProfileClick() {
    const path = ROUTES_PATH.ROUTE_PROFILE.PATH;
    history.push(path);
  }

  return (
    <>
      <HeaderBarStyle>
        <Row justify="space-between" align="middle">
          <Col span={3}></Col>
          <Col span={18} style={{ textAlign: 'center' }}>
            <TextLarge
              text={title}
              style={{
                color: 'white',
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block',
              }}
            />
          </Col>
          <Col span={3} style={{ textAlign: 'right', paddingRight: '10px' }}>
            {profile?.pictureUrl && (
              <img
                src={profile?.pictureUrl}
                alt="Profile"
                width="40"
                height="40"
                onClick={handleProfileClick}
                style={{ borderRadius: '50%', cursor: 'pointer' }}
              />
            )}
          </Col>
        </Row>
      </HeaderBarStyle>
    </>
  );
};

export default HeaderLayout;
